import styled from 'styled-components'

const StatsStyled = styled.div`
  .stats-container {
    .title-stats {
      font-size: 20px;
      line-height: 14px;
      color: #4ef076;
      padding-bottom: 10px;
    }
    .stats {
      row-gap: 16px;
      .stats-block {
        display: inline-block;
      }
    }
  }
`

export default StatsStyled
